<template>
    <div class="layout-header" @click.stop>
        <img class="layout-header__logo" src="@/assets/img/layout/logo.png" alt="OnOx">
        <div class="layout-header__wallet" @click="toggleWallet">
            <img class="layout-header__bnb" src="@/assets/img/layout/bnb.png" alt="">
            <span>{{this.$store.state.globalAddress.slice(0,4) +"***" +this.$store.state.globalAddress.slice(38,42)}}</span>
            <img
                class="layout-header__arrow"
                :class="{ open: walletShow }"
                src="@/assets/img/layout/arrow.png"
                alt=""
            >
            <div v-show="walletShow" class="layout-dropdown layout-dropdown--wallet">
                <div class="layout-dropdown__item" @click.stop="copyAddress">
                    <img class="layout-dropdown__icon" src="@/assets/img/layout/wallet-copy.png" alt="">
                    {{ $t('layout.copyAddress') }}
                </div>
                <div class="layout-dropdown__item" @click.stop="onSwitchWallet">
                    <img class="layout-dropdown__icon" src="@/assets/img/layout/wallet-switch.png" alt="">
                    {{ $t('layout.switchWallet') }}
                </div>
                <div class="layout-dropdown__item" @click.stop="onDisconnect">
                    <img class="layout-dropdown__icon" src="@/assets/img/layout/wallet-disconnect.png" alt="">
                    {{ $t('layout.disconnect') }}
                </div>
            </div>
        </div>
        <div class="layout-header__actions">
            <div class="layout-header__lang">
                <button class="layout-header__icon-btn" type="button" @click="toggleLang">
                    <img src="@/assets/img/layout/globe.png" alt="">
                </button>
                <div v-show="langShow" class="layout-dropdown layout-dropdown--lang">
                    <div
                        v-for="item in langs"
                        :key="item.value"
                        class="layout-dropdown__item"
                        :class="{ active: $i18n.locale === item.value }"
                        @click="handleLang(item.value)"
                    >
                        <span>{{ $t(item.label) }}</span>
                        <img v-if="$i18n.locale === item.value" class="layout-dropdown__check" src="@/assets/img/layout/lang-check.png" alt="">
                    </div>
                </div>
            </div>
            <button class="layout-header__icon-btn" type="button" @click="toggleNav">
                <img src="@/assets/img/layout/menu.png" alt="">
            </button>
        </div>

        <Popup
            v-model="navShow"
            position="right"
            get-container="#app"
            :style="{ width: '230px', height: '100%' }"
            overlay-class="layout-nav-overlay"
        >
            <div class="layout-nav" @click.stop>
                <button class="layout-nav__close" type="button" @click="navShow = false">
                    <img src="@/assets/img/layout/nav-close.png" alt="">
                </button>
                <div
                    v-for="item in navItems"
                    :key="item.path"
                    class="layout-nav__item"
                    :class="{ active: $route.name === item.path }"
                    @click="goNav(item)"
                >
                    <img class="layout-nav__icon" :src="item.icon" alt="">
                    <span>{{ item.title }}</span>
                    <img class="layout-nav__chevron" src="@/assets/img/layout/nav-chevron.png" alt="">
                </div>
            </div>
        </Popup>
    </div>
</template>

<script>
import { Toast, Popup } from 'vant';
import { setLanguage } from '@/utils/cookies';
import { Locale } from 'vant';
import { copyToClipboard } from '@/utils';

import axios from 'axios'
import Web3 from 'web3'
import contractaa from '../views/contract/index.js';

export default {
    name: 'layout-header',
    components: {
        Popup,
    },
    data() {
        return {
            walletShow: false,
            langShow: false,
            navShow: false,
            address: '0x0000',
            langs: [
                { value: 'zh-CN', label: 'layout.zh' },
                { value: 'zh-TW', label: 'layout.zhTw' },
                { value: 'en-US', label: 'layout.en' },
                { value: 'kr', label: 'layout.kr' },
                { value: 'jp', label: 'layout.jp' },
            ],
            shareLeaderCode:'',
            userName:'',
        };
    },
    computed: {
        shortAddress() {
            return '0x****000';
        },
        navItems() {
            return [
                { path: 'home', title: this.$t('menu.home'), icon: require('@/assets/img/layout/nav-home.png') },
                { path: 'exchange', title: this.$t('menu.exchange'), icon: require('@/assets/img/layout/nav-exchange.svg') },
                { path: 'mining', title: this.$t('menu.mining'), icon: require('@/assets/img/layout/nav-mine.png') },
                { path: 'earnings', title: this.$t('menu.assets'), icon: require('@/assets/img/layout/nav-earn.png') },
                { path: 'me', title: this.$t('menu.me'), icon: require('@/assets/img/layout/nav-me.png') },
            ];
        },
    },
    watch: {
        '$route.path'() {
            this.closeMenus();
        },
    },
    mounted() {
        document.addEventListener('click', this.closeMenus);

        this.shareLeaderCode = this.$route.query.share
        if(this.$store.state.globalAddress =="" || !this.$store.state.islogin){
            this.userlogin()
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeMenus);
    },
    methods: {
        closeMenus() {
            this.walletShow = false;
            this.langShow = false;
            this.navShow = false;
        },
        toggleWallet() {
            this.langShow = false;
            this.navShow = false;
            this.walletShow = !this.walletShow;
        },
        toggleLang() {
            this.walletShow = false;
            this.navShow = false;
            this.langShow = !this.langShow;
        },
        toggleNav() {
            this.walletShow = false;
            this.langShow = false;
            this.navShow = !this.navShow;
        },
        goNav(item) {
            this.navShow = false;
            if (item.path && this.$route.name !== item.path) {
                this.$router.push({ name: item.path });
            }
        },
        handleLang(lang) {
            this.$i18n.locale = lang;
            setLanguage(lang);
            if (this.$i18n.messages[lang]) {
                Locale.use(lang, this.$i18n.messages[lang]);
            }
            this.langShow = false;
        },
        async copyAddress() {
            //console.log(this.$store.state.globalAddress)
            await copyToClipboard(this.$store.state.globalAddress);
            Toast(this.$t('layout.copied'));
            this.walletShow = false;
        },
        async onSwitchWallet() {
            this.walletShow = false;
            await window.ethereum.request({
            method: 'wallet_requestPermissions',
            params: [
                {
                eth_accounts: {}
                }
            ]
            })
        },
        onDisconnect() {
            this.walletShow = false;

            this.$store.state.islogin = false;
            this.$store.state.globalAddress = ''
        },
        async userlogin(){
            var that = this;
            if(typeof window.ethereum !='undefined'  ){
                console.log('安装了插件')
                web3 = new Web3(window.ethereum);
                const chainId = await window.ethereum.request({
                    method: 'eth_chainId'
                })
                //console.log(chainId)
                if(chainId!='0x38'){
                    await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x38' }] // BSC
                    })
                }
                
                ethereum.request({ method: 'eth_requestAccounts' }).then(handleAccountsChanged=>{
                that.userName = Web3.utils.toChecksumAddress(handleAccountsChanged[0]);
                that.$store.state.globalAddress = that.userName;
                  //console.log("链接地址："+that.userName);
                  //签名
                    var vstr = "welcome";
                    vstr = web3.utils.utf8ToHex(vstr);

                    ethereum.request({method: "personal_sign",params: [vstr, that.userName],}).then((signature) => {
                            let _vcode = that.shareLeaderCode
                            let _sigin = signature
                            //console.log("签名："+signature);
                            //console.log("vode："+_vcode);

                            //ajax 提交注册信息
                            axios.post(contractaa.APIURL+'?cmd=login',"addr="+that.userName+"&singer="+_sigin+"&vcode="+_vcode).then(function (response) {
                            if (response.status === 200) {
                                    //console.log("axios请求状态")
                                    //console.log(response.data.Status)
                                    let _arr = response.data.Message.split('|')
                                    that.$store.state.vcode = _arr[0];
           
                                    if(!response.data.Status){
                                        that.$toast.fail(that.$t('layout.failed'))
                                        return;
                                    }
                                    //console.log(response.data.Message)
                                    that.$toast.success(that.$t('layout.success'));
                                    that.$store.state.islogin = true;
                                    that.$emit("ready")
                                }
                            })
                           

                        }).catch((err) => {
                            // 异常
                            console.log("签名提交出错："+err)
                        });
                }).catch((error) => {
                if (error.code === 4001) {
                    console.log('Please connect to MetaMask.');
                } else {
                    console.error("err:"+error);
                }
            });
                console.log('==');
            }
            else{
                console.log('没有安装插件')
            }
        },
    },
};
</script>

<style lang="less">
.layout-header {
    height: 44px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    position: relative;
    z-index: 22;
    overflow: visible;
    background: #F3F2ED;

    &__logo {
        width: 32px;
        height: 32px;
        flex-shrink: 0;
    }

    &__wallet {
        position: relative;
        margin-left: 112px;
        width: 127px;
        height: 30px;
        padding: 0 8px 0 6px;
        display: flex;
        align-items: center;
        background: #FFFFFF;
        border-radius: 10px;

        span {
            margin: 0 6px;
            font-size: 12px;
            color: #101126;
        }
    }

    &__bnb {
        width: 20px;
        height: 20px;
    }

    &__arrow {
        width: 12px;
        height: 12px;
        transition: transform 0.2s;

        &.open {
            transform: rotate(180deg);
        }
    }

    &__actions {
        margin-left: 12px;
        display: flex;
        align-items: center;
        gap: 12px;
    }

    &__lang {
        position: relative;
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        overflow: visible;
    }

    &__icon-btn {
        position: relative;
        width: 24px;
        height: 24px;
        padding: 0;
        border: 0;
        background: transparent;
        flex-shrink: 0;

        img {
            width: 24px;
            height: 24px;
            display: block;
        }
    }
}

.layout-dropdown {
    position: absolute;
    z-index: 30;
    top: 38px;
    background: #FFFFFF;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(16, 17, 38, 0.12);
    padding: 8px 0;
    min-width: 132px;


    &--wallet {
        left: 0;
        right: auto;
        top: 37px;
        width: 127px;
        min-width: 127px;
        padding: 8px 0 9px;
        border: 0.5px solid #E7E7E7;
        border-radius: 10px;
        box-shadow: none;
        overflow: visible;

        &::before {
            content: '';
            position: absolute;
            top: -6px;
            right: 14px;
            width: 12px;
            height: 12px;
            box-sizing: border-box;
            background: #FFFFFF;
            border: 0.5px solid #E7E7E7;
            border-right-color: transparent;
            border-bottom-color: transparent;
            transform: rotate(45deg);
            z-index: 1;
        }

        .layout-dropdown__item {
            position: relative;
            z-index: 2;
            height: 34px;
            padding: 0 15px;
        }
    }

    &--lang {
        right: 0;
        padding: 9px 0;
        left: 50%;
        top: 36px;
        transform: translateX(-60%);
        width: 127px;
        min-width: 127px;
        border: 0.5px solid #E7E7E7;
        border-radius: 10px;
        box-shadow: none;
        overflow: visible;

        &::before {
            content: '';
            position: absolute;
            top: -6px;
            right: 35%;
            width: 12px;
            height: 12px;
            box-sizing: border-box;
            background: #FFFFFF;
            border: 0.5px solid #E7E7E7;
            border-right-color: transparent;
            border-bottom-color: transparent;
            transform: translateX(50%) rotate(45deg);
            z-index: 1;
        }

        .layout-dropdown__item {
            opacity: 0.5;
            font-weight: 400;
            position: relative;
            z-index: 2;

            &.active {
                opacity: 1;
                font-weight: 400;
                background: rgba(252, 238, 153, 0.3);
            }

            &:first-child.active {
                border-radius: 9.5px 9.5px 0 0;
            }

            &:last-child.active {
                border-radius: 0 0 9.5px 9.5px;
            }
        }
    }

    &__item {
        height: 34px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 12px;
        color: #101126;
        white-space: nowrap;
    }

    &__check {
        width: 12px;
        height: 12px;
        margin-left: auto;
        flex-shrink: 0;
        position: relative;
        font-style: normal;

        &::after {
            content: '';
            position: absolute;
            left: 3.5px;
            top: 1px;
            width: 4px;
            height: 8px;
            border-right: 1.3px solid #101126;
            border-bottom: 1.3px solid #101126;
            transform: rotate(45deg);
            box-sizing: border-box;
        }
    }

    &__icon {
        width: 18px;
        height: 18px;
        margin-right: 6px;
        border-radius: 6px;
        object-fit: contain;
        flex-shrink: 0;
        display: block;
        background: #FEF39D;
    }
}

.layout-nav-overlay {
    background: rgba(16, 17, 38, 0.35) !important;
}

.layout-nav {
    height: 100%;
    background: #FFFFFF;
    padding-top: 8px;
    padding-top: 40px;
    &__close {
        width: 16px;
        height: 16px;
        margin: 0 0 21px 15px;
        padding: 0;
        border: 0;
        background: transparent;

        img {
            width: 16px;
            height: 16px;
            display: block;
        }
    }

    &__item {
        height: 60px;
        padding: 0 15px 0 15px;
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 14px;
        color: #101126;

        &.active span {
            font-weight: 600;
        }
    }

    &__icon {
        width: 26px;
        height: 26px;
        margin-right: 8px;
        object-fit: contain;
        flex-shrink: 0;
    }

    &__chevron {
        width: 12px;
        height: 12px;
        margin-left: auto;
        object-fit: contain;
    }
}
</style>
